import { useParams, useLocation } from "react-router";
import P2PTransferConfirmation from "./P2PTransferConfirmation";

// Wrapper component to handle route parameters
const P2PTransferConfirmationWrapper = () => {
  const { type } = useParams<{ type: string }>();

  const location = useLocation();
  // Extract values with default fallbacks to prevent undefined errors
  const amount = location.state?.amount ?? 0;
  const address = location.state?.address ?? '';
  const name = location.state?.name ?? '';
  const save_address = location.state?.save_address ?? false;

  return <P2PTransferConfirmation
    type={type}
    amount={amount}
    address={address}
    name={name}
    save_address={save_address}
  />;
};

export default P2PTransferConfirmationWrapper;